import moment from "moment";

// Returns the id of the row currently duplicating

function getDuplicateCustomer(customers) {
  var customerIsDuplicate = false;
  var duplicateId = "";

  for (let i = 0; i < customers.length; i++) {
    if (customerIsDuplicate) return duplicateId;

    let currentCustomer = customers[i];
    for (let j = 0; j < customers.length; j++) {
      // skip index of currentCustomer to erroneous comparison to self
      if (i !== j) {
        let secondaryCustomer = customers[j];
        if (isEqual(currentCustomer, secondaryCustomer)) {
          customerIsDuplicate = true;
          duplicateId = secondaryCustomer.id;
          break;
        }
      }
    }
  }

  function isEqual(customer1, customer2) {
    const firstName1 = customer1.firstName && customer1.firstName.toLowerCase();
    const firstName2 = customer2.firstName && customer2.firstName.toLowerCase();

    const lastName1 = customer1.lastName && customer1.lastName.toLowerCase();
    const lastName2 = customer2.lastName && customer2.lastName.toLowerCase();

    const dob1 = customer1.dob;
    const dob2 = customer2.dob;

    return (
      firstName1 === firstName2 && lastName1 === lastName2 && dob1 === dob2
    );
  }
}

function isDuplicateCustomerField(duplicateCustomerId, field) {
  return field.substring(field.indexOf("_") + 1) === duplicateCustomerId;
}

const validate = (values, props) => {
  // console.log("DEBUG validate props.getTravellerFormValues", props.travellerFormValues)

  const errors = {};
  // "phone" and "email" fields are for CONTACT INFORMATION sub-section
  // "agreementCheckbox" field is for agreement checkbox, and props.travellerFormValues is for PASSENGERS fields
  var requiredFields = ["phone", "email", "agreementCheckbox"].concat(
    props.travellerFormValues
  );

  const duplicateCustomerId = getDuplicateCustomer(
    props.customerInfo.travellers
  );

  requiredFields.forEach(field => {
    if (isEmpty(values[field])) {
      errors[field] = "Required";
    } else if (field.slice(0, 3) === "dob") {
      // If date of birth (dob) field
      if (values[field].length !== 10) {
        errors[field] = "Enter complete date";
      } else if (
        values[field].length === 10 &&
        !moment(values[field], "YYYY-MM-DD", true).isValid()
      ) {
        errors[field] = "Enter valid date";
      }
    }

    if (isDuplicateCustomerField(duplicateCustomerId, field)) {
      errors[field] = "Duplicate";
    }
  });

  if (!isValidEmail(values.email)) {
    errors.email = "Enter valid email";
  }

  // UTIL
  function isEmpty(str) {
    if (!str) return true;
    if (typeof str === "string") return !!str.trim() === false;
    return false;
  }

  // http://stackoverflow.com/a/46181/2213882
  function isValidEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/scenes/ReviewOrder/CustomerInfoForm/validate.js